import React, { useEffect, useState } from "react";
import { View, Text, TouchableOpacity, Button, Picker, TextInput, StyleSheet, Dimensions} from "react-native";
import CreditCard from "../CardComponent/CardComponet";
import CreditCardModal from "../CreditCardModalComponent/CreditCardModalComponent";


const {height, width} = Dimensions.get('window');

const CreditCards = ({allCreditCardInfo, contractId, updateAllCreditCardInfo}) => {

    //默认选择第一张卡
    const [selectedCard, setSelectedCard] = useState(allCreditCardInfo[0]);

    const [allCardNumber, setAllCardNumber] = useState(allCreditCardInfo.map((creditCardInfo)=> creditCardInfo.cardNumber));

    const [editModalVisible, setEditModalVisible] = useState(false);
    const [addModalVisible, setAddModalVisible] = useState(false);

    const [currentUserContractId, setContractId] = useState(contractId[0].contractId);
    
    const handleCardChange = (cardNumber) =>{
        const selectedCardInfo = allCreditCardInfo.find((card)=>card.cardNumber === cardNumber)
        setSelectedCard(selectedCardInfo);
    }

    const openAddModal = ()=> {
        console.log('open add modal')
        if(editModalVisible){
            setEditModalVisible(!editModalVisible);
        }
        setAddModalVisible(!addModalVisible);
    }

    const openEditModal = () => {
        console.log('open edit modal')
        if(addModalVisible){
            setAddModalVisible(!addModalVisible);
        }
        setEditModalVisible(!editModalVisible);
    } 

    return(
        <View style={ {marginTop: 10} }>
            <View style={[styles.buttonContainer]}>
                <TouchableOpacity onPress={openAddModal} style={[styles.touchableButton, {backgroundColor: '#6f805c'}]}>
                    <Text style={styles.tochableText}>Add a new card</Text>
                </TouchableOpacity>
            </View>


            <View style={[styles.pickerContainer, {marginTop: 20}]}>
                <Picker
                    selectedValue={selectedCard? selectedCard.cardNumber : null}
                    onValueChange={handleCardChange}
                    style={[{height: 40, width: 150}]}
                >{
                    allCreditCardInfo.map((card, index)=>(
                        <Picker.Item
                            key={index}
                            label={'xxxx '+card.cardNumber.substring(card.cardNumber.length-4)}
                            value={card.cardNumber}
                        />
                    ))
                }
                </Picker>
            </View>
            {(selectedCard)&&<View style={[{padding: 20, marginTop: 20}]}>
                <Cards
                    cvc={selectedCard.cardCode}
                    expiry={`${selectedCard.cardExpMonth}/${selectedCard.cardExpYear.substring(selectedCard.cardExpYear.length - 2)}`}
                    name={selectedCard.cardHolderName}
                    number={selectedCard.cardNumber}
                />
            </View>}

            <View style={[styles.buttonContainer]}>
                <TouchableOpacity onPress={openEditModal} style={[styles.touchableButton]}>
                    <Text style={[styles.tochableText]}>Edit</Text>
                </TouchableOpacity>
            </View>

            {editModalVisible && (<View>
                <CreditCardModal
                    selectedCard={selectedCard}
                    isVisible={editModalVisible}
                    formTitile={'Edit default credit card'}
                    contractId={currentUserContractId}
                    allCardNumber = {allCardNumber}
                    updateAllCreditCardInfo={updateAllCreditCardInfo}
                    updateModalVisible={openEditModal}
                />
                </View>)}

            {addModalVisible && (<View>
                <CreditCardModal
                    selectedCard={null}
                    isVisible={addModalVisible}
                    formTitile={'Add a new credit card to your account'}
                    contractId={currentUserContractId}
                    allCardNumber = {allCardNumber}
                    updateAllCreditCardInfo={updateAllCreditCardInfo}
                    updateModalVisible={openAddModal}
                />
            </View>)}
        </View>
    )
}


const styles = StyleSheet.create({
    buttonContainer: {
        alignItems: 'center',
        padding: 20,
    },
    pickerContainer: {
        alignItems: 'center', 
        padding: 20, 
    },
    touchableButton:{
        backgroundColor: '#2196F3',
        paddingVertical: 12,
        paddingHorizontal: 24,
        borderRadius: 5,
        alignItems: 'center',
        justifyContent: 'center',
        width: 200,
    },
    tochableText: {
        color: '#FFFFFF',
        fontSize: 16,
        fontWeight: '400',     
    }
  });

export default CreditCards;